export default {
  created() {
    this.getBanners();
  },

  data() {
    return {
      bannerList: [],
      showPopup: false,
      firstBannerId: null
    };
  },

  computed: {
    // 检查是否有第一张图片
    hasFirstBanner() {
      return this.bannerList.length > 0;
    }

  },
  methods: {
    async getBanners() {
      const bannerList = await this.$http.getBannerList();
      this.bannerList = bannerList; // 保存第一张banner的id

      if (this.bannerList.length > 0) {
        this.firstBannerId = this.bannerList[0].id;
      }
    },

    getBannerUrl(target_type, target_url, id) {
      if (this.firstBannerId == id) {
        this.showPopup = true;
        return;
      }

      if (!target_url) return;

      switch (target_type) {
        case 1:
        case 3:
          target_url && window.open(target_url);
          break;

        case 2:
          window.location.href = `/${$schoolUrl}/bannerDetail.html?bannerCon=${id}`;

        default:
          break;
      }
    }

  }
};